<template>
  <div v-cloak v-if="!userType && loggedIn" id="page-wrapper">
    <EplNewPageHeader :activeLink="'home'"></EplNewPageHeader>
    <div v-if="user.profile_complete&&(!user.limitUnderReview)" class="container content-wrap">
      <div class="row stat-section">
        <div class="col-md-12">
          <div class="stat-container">
            <div class="stat-item item-bg">
              <div class="row row-6">
                <div class="col-md-6 stat-col-6 pl-32">
                  <p class="title">{{ user.available_credit_limit || "0.00" | formatCurrency }}</p>
                  <p class="subtitle">Available credit limit</p>
                </div>
                <div class="col-md-6 stat-col-6 pl-32" v-if="user.features.loyalty">
                  <p class="title">{{ user.features.loyalty.redeemable_points }}</p>
                  <p class="subtitle">Total Loyalty Points</p>
                </div>
              </div>
            </div>
            <div class="stat-item">
              <div class="row row-4">
                <div class="col-md-5 stat-col-4">
                  <p class="title">
                    {{
                    user.statement_details.totalOutstandingAmount ||
                    "0.00" | formatCurrency
                    }}
                  </p>
                  <p class="subtitle">Total&nbsp;Outstanding</p>
                </div>
                <div class="col-md-4 stat-col-4">
                  <p class="title">
                    {{
                    user.statement_details
                    .previousStatementOutstandingAmount ||
                    "0.00" | formatCurrency
                    }}
                  </p>
                  <p class="subtitle">Statement&nbsp;Outstanding</p>
                </div>
              </div>
              <div class="row row-4 mt-10">
                <div
                  class="col-md-5 stat-col-4"
                  v-if="user.statement_details.statementGeneratedDate"
                >
                  <p class="row_title">{{ user.statement_details.statementGeneratedDate }}</p>
                  <p class="row_subtitle">Statement&nbsp;Generated</p>
                </div>
                <div class="col-md-4 stat-col-4" v-if="user.statement_details.statementDueDate">
                  <p class="row_title">{{ user.statement_details.statementDueDate }}</p>
                  <p class="row_subtitle">Statement&nbsp;Due&nbsp;Date</p>
                </div>
                <div
                  class="col-md-3 stat-col-4"
                  v-if="
                    user.statement_details.totalOutstandingAmount >= 0 ||
                      user.statement_details
                        .previousStatementOutstandingAmount >= 0
                  "
                >
                  <button class="action_button pull-right" @click="showOutstandingSection()">Pay Now</button>
                </div>
              </div>
            </div>

            <div class="stat-item">
              <div class="row row-text-image">
                <div class="col-md-9 stat-col-8">
                  <p class="title">Download App and Create Your UPI ID</p>
                </div>
                <div class="col-md-3">
                  <img src="/static/images/svgs/group-copy.svg" class="pull-right" />
                </div>
              </div>
              <div class="row row-text-image">
                <div class="col-md-9 stat-col-8">
                  <p class="subtitle">Transact on any merchant using UPI</p>
                </div>
                <div class="col-md-3 stat-col-8">
                  <a
                    href="https://play.google.com/store/apps/details?id=in.epaylater.android.consumer&hl=en_IN"
                    target="_blank"
                    class="action_button pull-right"
                  >Download</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="info-message"
        v-if="user.kycRequired || user.emandateRequired || user.isCreditPaused"
      >
        <p class="info-message__content">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ff0000"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="bevel"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12" y2="8" />
          </svg>
          <span class="info-message__content__text">
            {{
            user.kycEmandateMessage || user.creditPauseMessage
            }}
          </span>
        </p>
        <router-link
          class="action-button--no-underline"
          :to="{
            name: user.kycRequired
              ? 'KYC Step 1'
              : user.emandateRequired
              ? 'eMandate'
              : false
          }"
          v-if="user.kycRequired || user.emandateRequired"
        >
          <ActionButton title="Complete Now" class="action-button--small-font" />
        </router-link>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="bbps-header">
            <p class="bbps-header__title">Bill Payments and Recharges</p>
            <img class="bbps-header__logo" :src="bbpsImages.screenIcon" alt="BBPS Logo" />
          </div>
          <QuickLinks :title="this.title" @on-click="checkGraceTxns"></QuickLinks>
        </div>
      </div>
    </div>
    <div
      class="container content-wrap"
      v-else-if="(!user.profile_complete)||(user.profile_complete&&user.limitUnderReview)"
    >
      <div class="row">
        <div class="col-xs-12">
          <div class="user-signup-pending">
            <img src="/static/images/pending.svg" alt="Pending" />
            <p class="user-signup-pending__message">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#4d4d4d"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12" y2="16" />
              </svg>
              {{user.limitReviewMessage}}
            </p>
          </div>
        </div>
      </div>
      <div
        class="info-message"
        v-if="user.profile_complete&&(user.kycRequired || user.emandateRequired || user.isCreditPaused)"
      >
        <p class="info-message__content">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ff0000"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="bevel"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12" y2="8" />
          </svg>
          <span class="info-message__content__text">
            {{
            user.kycEmandateMessage || user.creditPauseMessage
            }}
          </span>
        </p>
        <router-link
          class="action-button--no-underline"
          :to="{
            name: user.kycRequired
              ? 'KYC Step 1'
              : user.emandateRequired
              ? 'eMandate'
              : false
          }"
          v-if="user.kycRequired || user.emandateRequired"
        >
          <ActionButton title="Complete Now" class="action-button--small-font" />
        </router-link>
      </div>
      <div class="row">
        <div class="col-md-12">
          <QuickLinks :title="this.title" @on-click="checkGraceTxns"></QuickLinks>
        </div>
      </div>
    </div>
    <div class="hidden-xs" v-if="PaymentSection">
      <payment />
    </div>
    <div class="hidden-xs" v-if="outstandingSection">
      <outstandingDetails />
    </div>
  </div>
</template>

<script>
import EplNewPageHeader from "./EplNewPageHeader/index";
import QuickLinks from "./EplNewQuickLinks/index";
import TransactionsDetailedHeader from "./TransactionsDetailedHeader/index";
import outstandingDetails from "./OutstandingDetails/index";
import Payment from "./PaymentMode/index";
import ActionButton from "@/components/ActionButton";

import { mapGetters } from "vuex";

export default {
  name: "V2Dashboard",
  data() {
    return {
      activeCategory: undefined,
      widthArray: [],
      tabNaviPosition: 0,
      nextOffset: 0,
      navWidth: 0,
      leftOffset: 0,
      useSlider: false,
      PaymentSection: false,
      outstandingSection: false,
      title: this.$route.meta.value
        ? this.$route.meta.value
        : this.$route.params.category,
      promotions: [
        { logoUrl: "/static/images/pngs/banner_img.png" },
        { logoUrl: "/static/images/pngs/banner_img.png" }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "categories",
      "userType",
      "loggedIn",
      "user",
      "signupStatus",
      "bbpsImages"
    ])
  },
  components: {
    EplNewPageHeader,
    QuickLinks,
    TransactionsDetailedHeader,
    outstandingDetails,
    Payment,
    ActionButton
  },
  created() {},
  methods: {
    showPaymentSection() {
      this.outstandingSection = false;
      this.PaymentSection = !this.PaymentSection;
    },
    showOutstandingSection() {
      this.PaymentSection = false;
      this.outstandingSection = !this.outstandingSection;
    },
    checkGraceTxns(link) {
      if (
        (this.user.kycRequired || this.user.emandateRequired) &&
        this.$route.path !== link
      ) {
        this.$emit("showGraceTxnsModal", link);
      } else if (this.$route.path === link) {
        this.$router.push({ name: "Dashboard" });
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import "../assets/sass/variables";
#page-wrap {
  .content-wrap {
    padding: 0px;
  }
}
.categoriesList {
  left: 0;
  position: relative;
}
.categoriesTabsWrapper {
  overflow: auto;
  @media screen and (min-width: $md) {
    overflow: hidden;
  }
  @media screen and (max-width: $md) {
    display: block;
    margin: 0 -15px;
    width: 100vw;
    overflow: hidden;
  }
}

.nav_ctrl {
  box-shadow: none;
  line-height: 50px;
}

img[alt="prev"] {
  transform: rotate(180deg);
}
.content {
  @media screen and (min-width: $md) {
    background: #fff;
  }
  border-radius: 6px;

  .merchantListWrapper {
    margin: 40px 0;
    ul {
      margin: 0;
      padding: 0;
      display: flex;
      flex-wrap: wrap;
      li {
        align-items: stretch;
        flex: 1 0 50%;
        @media screen and (min-width: $sm) {
          max-width: 50%;
          flex: 1 0 33.33%;
        }
        @media screen and (min-width: $md) {
          max-width: 25%;
          flex: 1 0 20%;
        }
        display: flex;
        justify-content: space-between;
        a {
          flex: 1 0;
          padding: 0 10px;
          align-items: center;
          figure {
            .img-wrap {
              background: #fff;
              border-radius: 6px;
              position: relative;
              min-height: 80px;
              img {
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                margin: auto;
                max-width: 80%;
                max-height: 60px;
              }
            }
            figcaption {
              margin-bottom: 20px;
              h4 {
                margin: 0;
                font-family: Overpass;
                font-size: 14px;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: normal;
                letter-spacing: -0.2px;
                text-align: center;
                color: #979797;
              }
              p {
                font-family: Overpass;
                font-size: 12px;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #718099;
              }
            }
          }
        }
      }
    }
  }
  .tabHeader {
    border-bottom: solid thin rgba(75, 85, 102, 0.08);
    nav {
      overflow: hidden;
      @media screen and (max-width: $md) {
        overflow: auto;
        background: #fff;
        margin: 0 -15px;
        display: block;
      }
      ul {
        margin: 0;
        li {
          margin: 0 10px;
          a {
            display: block;
            line-height: 46px;
            margin: 0;
            font-size: 14px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            letter-spacing: -0.2px;
            text-align: left;
            border-top: solid 3px transparent;
            border-bottom: solid 3px transparent;
            box-sizing: border-box;
            color: #718099;
            &.active {
              border-bottom: solid 3px #fd7f5b;
            }
          }
        }
      }
    }
  }
}
.content-section {
  background-color: #ffffff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin-top: -10px;
  overflow: hidden;
  padding: 0;
  @media screen and (min-width: $md) {
    border-radius: 10px;
    margin-top: 0;
    min-height: 650px;
  }
  @media screen and (min-width: $md) {
    border-radius: 0px;
    background: white;
  }
  @media screen and (max-width: $md) {
    margin-top: 0;
    margin-bottom: 40px;
  }
}

.stat-container {
  display: flex;
  width: 100%;
}
.mt-10 {
  margin-top: 10px;
}

.action_button {
  border-radius: 3px;
  background-color: #3482fd;
  font-size: 12.5px;
  font-weight: 200;
  letter-spacing: -0.07px;
  color: #ffffff;
  padding: 5px 10px;
  text-align: center;
  box-shadow: none;
  outline: none;
  border: none;
  line-height: normal;
  text-decoration: none;
}
.stat-section {
  .stat-item {
    flex: 1;
    padding: 16px;
    background: #f9f9f9;
    margin: 8px;
    .row-4 {
      padding: 0px 10px;
      .stat-col-4 {
        padding: 0px;
        .row_title {
          margin: 0;
          vertical-align: baseline;
          line-height: 12px;
          font-size: 12px;
          letter-spacing: 1.24px;
          color: #4d4d4d;
          font-weight: bold;
        }
        .row_subtitle {
          margin: 0;
          vertical-align: baseline;
          line-height: 10px;
          font-size: 10px;
          letter-spacing: 1.24px;
          color: #979797;
        }
      }
    }
    .row-text-image {
      margin: auto;
      padding: 0px 10px;
      .stat-col-8 {
        padding: 0px;
        .title {
          margin: 0;
          vertical-align: baseline;
          line-height: 22px;
          font-size: 15px;
          color: #4d4d4d;
          font-weight: bold;
          letter-spacing: normal;
        }
        .subtitle {
          line-height: 16px;
          font-size: 14px;
          color: #979797;
          margin: 0;
          letter-spacing: 0.16px;
        }
      }
    }
    .row-6 {
      margin: auto;
      .stat-col-6 {
        .title {
          margin: 0;
          vertical-align: baseline;
          line-height: 20px;
          font-size: 20px;
          letter-spacing: 1.17px;
          color: #4d4d4d;
        }
        .subtitle {
          line-height: 16px;
          font-size: 10px;
          letter-spacing: 0.7px;
          color: #979797;
          margin: 0;
        }
      }
    }
    .title {
      margin: 0;
      vertical-align: baseline;
      line-height: 20px;
      font-size: 20px;
      letter-spacing: 1.17px;
      color: #4d4d4d;
    }
    .subtitle {
      line-height: 16px;
      font-size: 10px;
      letter-spacing: 0.7px;
      color: #979797;
      margin: 0;
    }
  }
  .stat-item.item-bg {
    padding-top: 35px;
  }
}
.pl-32 {
  padding-left: 32px;
}
.info-message {
  margin: 2rem 1rem;
  padding: 1.5rem 3rem;
  background: #ffe5e6;
  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
    &__text {
      margin-left: 0.5rem;
      color: var(--red);
    }
  }
}
.action-button {
  &--no-underline {
    width: max-content;
    text-decoration: none;
    margin-top: 2.6rem;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
  &.action-button--small-font {
    font-size: 1.3rem;
  }
}
.user-signup-pending {
  background: var(--gray-12);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1rem;
  padding: 3rem;
  &__message {
    font-size: 1.8rem;
    font-weight: 300;
    line-height: 1.56;
    color: var(--gray-2);
    margin-top: 4rem;
    display: flex;
    align-items: center;
  }
}
.bbps-header {
  display: flex;
  justify-content: space-between;
  padding: 8px;
  align-items: center;
  &__title {
    font-size: 14px;
    color: #4d4d4d;
    margin-bottom: 0;
  }
  &__logo {
    width: 80px;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EplNewDashboardHeader.vue